import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CATALOGS,
  RESOURCE_LEVEL,
  RESOURCES,
  ADD_RESOURCE,
  ADD_RESOURCE_LEVEL,
} from "../../../constants/route-paths";
import {
  deleteLabor,
  getLaborList as getLaborListAPI,
  editLabor as editLaborAPI,
  getLevels as getLevelsAPI,
  updateLevel,
} from "./../../../actions/inventory.action";
import DeleteDialog from "./../../../components/delete-dialog";
import { Link } from "react-router-dom";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import CustomTable from "../../../components/table/table";
import { addResourcesAction, addLevelsAction, clearResourcesAction } from "../../../slice/resources";
import { toUSD } from "../../../util/currency-formatter";
import DeleteIcon from '@mui/icons-material/Delete';
import { useNavigate } from "react-router";

export default function LaborList({ writePermission, ...props }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let resources = useSelector(state => state.resources.list);
  let levels = useSelector(state => state.resources.levels || []);
  const [state, setState] = useState({
    open: false,
    deleteDialogState: false,
    openAddLevelDialog: false,
    level_column: [],
    resource_column: []
  });
  const [activeResourceTab, setActiveResourceTab] = useState(sessionStorage.getItem('resourceActiveTab') || 'resource');

  useEffect(() => {
    if (activeResourceTab === 'resource' && !resources.length) getLaborList({ sortBy: 'skill' });
    if (activeResourceTab === 'levels' && !levels.length) getLevels();
    getColumns();

    return () => {
      if (!window.location.pathname.includes(`/${CATALOGS}/${RESOURCES}`)) {
        dispatch(clearResourcesAction());
      }
    };
  }, []);


  const getColumns = () => {
    setState(prev => ({
      ...prev,
      resource_column: [
        { title: "S No", field: "sno" },
        {
          title: "Skill",
          field: "skill",
          render: (rowData) => (
            <Link to={`/${CATALOGS}/${RESOURCES}/edit/${rowData.id}`}>
              {rowData.skill}
            </Link >
          ),
        },
        { title: "Average Cost / Unit", field: "cost", render: (rowData) => toUSD(rowData.cost), class: 'text-right' },
        {
          title: "Status",
          field: "status",
          filtering: false,
          class: 'text-center',
          render: (rowData) => (
            <div className="form-check form-switch d-flex justify-content-center">
              <input
                className="form-check-input switch-checkbox"
                type="checkbox"
                role="switch"
                id={`statusSwitch-${rowData.id}`}
                disabled={writePermission ? false : true}
                checked={rowData.status === "ACTIVE" ? true : false}
                onChange={(e) => {
                  const newStatus = e.target.checked ? "ACTIVE" : "INACTIVE";
                  dispatch(editLaborAPI({ status: newStatus }, rowData.id, { hideLoader: true, updateLocally: true, hideMessage: true }))
                    .catch(e => console.error(e));
                }}
              />
              <label className="form-check-label" htmlFor={`statusSwitch-${rowData.id}`}></label>
            </div>
          ),
        },
        {
          title: "Personnel",
          field: "is_personnel",
          filtering: false,
          class: 'text-center',
          render: (rowData) => (
            <div className="form-check form-switch d-flex justify-content-center">
              <input
                className="form-check-input switch-checkbox"
                type="checkbox"
                role="switch"
                id={`personnelSwitch-${rowData.id}`}
                disabled={writePermission ? false : true}
                checked={rowData.is_personnel !== false}
                onChange={(e) => {
                  const newPersonnel = e.target.checked;
                  dispatch(editLaborAPI({ isPersonnel: newPersonnel }, rowData.id, { hideLoader: true, updateLocally: true, hideMessage: true })).catch(e => console.error(e));
                }}
              />
              <label className="form-check-label" htmlFor={`personnelSwitch-${rowData.id}`}></label>
            </div>
          ),
        },
      ],
      level_column: [
        { title: "S No", field: "sno" },
        {
          title: "Name",
          field: "name",
          render: (rowData) => (
            <Link to={`/${CATALOGS}/${RESOURCE_LEVEL}/edit/${rowData.id}`}>
              {rowData.name}
            </Link>
          ),
        },
        { title: "Description", field: "description" },
        // {
        //   title: "Call out Cost",
        //   field: "calloutCost",
        //   render: (rowData) => numberFormat(rowData.calloutCost),
        // },
        // {
        //   title: "Travel Cost",
        //   field: "travelCost",
        //   render: (rowData) => numberFormat(rowData.travelCost),
        // },
        {
          title: "Status",
          field: "status",
          filtering: false,
          render: (rowData) => (
            <div className="form-check form-switch">
              <input
                className="form-check-input switch-checkbox"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                disabled={writePermission ? false : true}
                checked={rowData.status}
                onChange={(e) => {
                  dispatch(updateLevel({ status: e.target.checked }, rowData.id)).then((data) => {
                    getLevels();
                  });
                }}
              />
              < label className="form-check-label" htmlFor="flexSwitchCheckDefault"></label>
            </div>
          ),
        },
      ]
    }));
  };

  const getLevels = () => {
    const levelsList = [];
    const params = { sortBy: 'name' };
    dispatch(getLevelsAPI(params)).then((data) => {
      (data || []).forEach((level, i) => {
        level.sno = i + 1;
        levelsList.push(level);
      });
      dispatch(addLevelsAction(levelsList));
    }).catch(e => console.error(e));
  };

  const getLaborList = () => {
    dispatch(getLaborListAPI()).then((data) => {
      let labors = (data || []).map((labor, i) => {
        labor.sno = i + 1;
        return labor;
      })
      dispatch(addResourcesAction(labors));
    }).catch(e => console.error(e))
  };

  const deleteDialogHandler = (id = "", skill = "") => {
    setState(prev => ({
      ...prev,
      deleteDialogState: !prev.deleteDialogState,
      deleteId: id,
      deleteName: skill,
    }));
  };

  const deleteHandler = (id) => {
    dispatch(deleteLabor(id)).then((res) => {
      setState(prev => ({
        ...prev,
        deleteDialogState: false,
      }));
      getLaborList();
    });
  };

  const addLabor = () => {
    navigate(`/${CATALOGS}/${ADD_RESOURCE}`);
  };

  const editLabor = (id) => {
    navigate(`/${CATALOGS}/${RESOURCES}/edit/${id}`);
  };

  const addLevel = () => {
    navigate(`/${CATALOGS}/${ADD_RESOURCE_LEVEL}`);
  };

  const editLevel = (id) => {
    navigate(`/${CATALOGS}/${RESOURCE_LEVEL}/edit/${id}`);
  };

  return (
    <>
      <DeleteDialog
        open={state.deleteDialogState}
        id={state.deleteId}
        deleteHandler={deleteHandler}
        dialogClose={deleteDialogHandler}
        moduleName={`Resource - ${state.deleteName}`}
        description={`Resource - ${state.deleteName}`}
      />

      <div className="purchase-order-block">
        <div className="row">
          <div className="w-auto">
            <h2 className="content-heading text-uppercase">Resources</h2>
          </div>
          {writePermission && (<div className="w-auto ms-auto mt-auto">
            <button onClick={addLabor} className="secondarybtn secondarybtn-outline btn-ch btn btn-primary me-2">Add Resource</button>
            <button onClick={addLevel} className="secondarybtn secondarybtn-outline btn-ch ms-auto btn btn-primary">Add Cost/Sales Level</button>
          </div>)}
        </div>

        <div className="row">
          <div className="col-12">
            <Tabs
              defaultActiveKey={activeResourceTab}
              activeKey={activeResourceTab}
              id="uncontrolled-tab-example"
              className="mb-3"
              onSelect={k => {
                sessionStorage.setItem('resourceActiveTab', k);
                setActiveResourceTab(k);
                if (k === 'levels' && !levels.length) {
                  getLevels();
                } else if (k === 'resource' && !resources.length) {
                  getLaborList({ sortBy: 'skill' });
                }
              }}
            >
              <Tab eventKey="resource" title={resources.length ? `Resources (${resources.length})` : 'Resources'}>
                <CustomTable
                  columns={state.resource_column}
                  data={resources}
                  isEdit={writePermission}
                  isMoreIcon={<DeleteIcon />}
                  editHandler={(data) => editLabor(data.id)}
                  isDelete={writePermission ? true : false}
                  deleteHandler={(data) => deleteDialogHandler(data.id, data.skill)}
                  fileName='Resources List'
                />
              </Tab>
              <Tab eventKey="levels" title={levels.length ? `Cost/Sales Levels (${levels.length})` : 'Cost/Sales Levels'}>
                <CustomTable
                  columns={state.level_column}
                  data={levels}
                  isEdit={writePermission}
                  editHandler={(data) => editLevel(data.id)}
                  fileName='Cost/Sales Level List'
                />
              </Tab>
            </Tabs>
          </div>
        </div>
      </div>
    </>
  );

}
